export default "__VITE_ASSET__oEvCyeKB__"